export const ADD_PROPERTY_AS_INPUT = 'ADD_PROPERTY_AS_INPUT';

export const addPropertyAsInput = ({ propertyIds, flowBlockId }) => ({
  type: ADD_PROPERTY_AS_INPUT,
  payload: {
    propertyIds,
    flowBlockId,
  },
});
